import { HttpClient } from '../../httpClient'
import { OpalApiRequestParams } from '../../schema'

type DeleteBoardObjectArguments = OpalApiRequestParams<'DeleteBoardObjectV3'>

// The BoardObject Delete endpoint does not return data,
// only a response with a `204` status code. Because
// of that, we will hard code `null` as the response
export async function deleteBoardObject(
  params: DeleteBoardObjectArguments
): Promise<null> {
  const url = new URL(
    `/board_objects/v3/${params.path.board_object_id}`,
    window.location.origin
  )

  return HttpClient()
    .delete(url.toString())
    .then(() => null)
}
